import { PERFORMS, CONTRIBUTES } from "@/assets/js/tactics/pitch/responsibilities";
import DefensivePressurePerformance from "./performances/flank/defensive-pressure";
import CreatingChancesPerformance from "./performances/flank/creating-chances";
import DefensiveCoverPerformance from "./performances/flank/defensive-cover";
import StretchingPlayPerformance from "./performances/flank/stretching-play";


export default class FlankResponsibilityPerformances {
  constructor() {
    this.defensivePressure = new DefensivePressurePerformance();
    this.creatingChances = new CreatingChancesPerformance();
    this.defensiveCover = new DefensiveCoverPerformance();
    this.stretchingPlay = new StretchingPlayPerformance();
  }

  countPerformance(performances) {
    for (const responsibility of Object.keys(performances)) {

      if (performances[responsibility].performs === PERFORMS) {
        this[responsibility].addPerformer(performances[responsibility].atypically);
        continue;
      }
      if (performances[responsibility].performs === CONTRIBUTES) {
        this[responsibility].addContributor(performances[responsibility].atypically);
      }
    }
  }
}
